import React from "react";
import { Box, Typography, Container, Button } from "@mui/material";

const YouTubeTagGeneratorContent = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Container maxWidth="md" sx={{ textAlign: "center", mt: 4 }}>
      {/* Intro */}
      <Typography variant="h4" fontWeight="bold" sx={{ fontSize: "1.75rem" }} gutterBottom>
        Generate YouTube Tags Instantly
      </Typography>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Boost Your Video's Reach with Smart SEO Tags
      </Typography>
      <Typography variant="body1" paragraph>
        Struggling to find the right tags for your YouTube videos? You're not alone. The right keywords can skyrocket your visibility and engagement.
      </Typography>
      <Typography variant="body1" paragraph>
        Our YouTube Tag Generator analyzes your video and suggests optimized tags tailored for YouTube's algorithm—fast, accurate, and free.
      </Typography>

      {/* Features */}
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Why Use This Tag Generator?
      </Typography>
      <ul style={{ textAlign: "left", display: "inline-block" }}>
        <li>🔍 Instantly generate tags based on your video title or content</li>
        <li>🎯 SEO-optimized keywords to help rank higher in search</li>
        <li>🧠 AI-enhanced suggestions based on trending topics</li>
        <li>📋 Copy tags with one click—no fluff, just useful keywords</li>
      </ul>

      {/* How It Works */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        How to Generate YouTube Tags
      </Typography>
      <ol style={{ textAlign: "left", display: "inline-block" }}>
        <li>Log in to MyFreshTools and open the YouTube Tag Generator tool.</li>
        <li>Enter your video title or a brief description.</li>
        <li>Click “Generate Tags” to get relevant keyword suggestions.</li>
        <li>Copy and paste the tags directly into your YouTube video settings.</li>
      </ol>

      {/* FAQs */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        Frequently Asked Questions (FAQs)
      </Typography>
      <Typography variant="body1" fontWeight="bold">🎯 How accurate are these tags?</Typography>
      <Typography variant="body2" paragraph>
        We use keyword data and SEO principles to suggest tags that align with YouTube's algorithm and current trends.
      </Typography>

      <Typography variant="body1" fontWeight="bold">🆓 Is this really free?</Typography>
      <Typography variant="body2" paragraph>
        Yes! You can generate tags for free with basic usage. Upgrade to get unlimited suggestions and access to trend-based enhancements.
      </Typography>

      <Typography variant="body1" fontWeight="bold">📈 Will this help my videos rank better?</Typography>
      <Typography variant="body2" paragraph>
        Absolutely. Relevant tags improve discoverability by making your content more searchable to the right audience.
      </Typography>

      {/* CTA */}
      <Box mt={4}>
        <Button variant="contained" color="primary" size="large" onClick={scrollToTop}>
          Generate Your YouTube Tags Now
        </Button>
      </Box>
    </Container>
  );
};

export default YouTubeTagGeneratorContent;
